<template>
  <v-dialog v-model="isOpen" max-width="420px" persistent>
    <v-card>
      <v-card-title class="justify-space-between">
        <div>
          {{ $t('two_factor.login_title') }}
          <div class="text--secondary text-caption">
            {{ mode==='otp' ? $t('two_factor.login_subtitle') : $t('two_factor.recovery_subtitle') }}
          </div>
        </div>
        <v-chip small>{{ mode==='otp' ? 'OTP' : $t('two_factor.recovery_chip_title') }}</v-chip>
      </v-card-title>

      <v-divider/>

      <v-card-text>
        <!-- OTP FIELD -->
        <v-text-field
          v-if="mode==='otp'"
          v-model="otpCode"
          :label="$t('two_factor.otp_code_label')"
          :error-messages="errorMsg['otp_code']"
          prepend-icon="mdi-shield-key-outline"
          type="tel"
          maxlength="6"
          @input="otpOnlyDigits"
          autocomplete="one-time-code"
          autofocus
        />

        <!-- RECOVERY FIELD -->
        <v-text-field
          v-else
          v-model="recoveryCode"
          :label="$t('two_factor.recovery_code_label')"
          :error-messages="errorMsg['otp_code']"
          prepend-icon="mdi-shield-key-outline"
          type="text"
          maxlength="64"
          @input="recoveryCodeRules"
          autofocus
        />

        <div class="text-caption mt-2">
          <a href="#" @click.prevent="toggleMode">
            {{ mode==='otp' ? $t('two_factor.use_recovery_code') : $t('two_factor.use_otp_code') }}
          </a>
        </div>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer/>
        <v-btn text :disabled="busy" @click="onCancel">{{ $t('cancel') }}</v-btn>
        <v-btn
          color="primary"
          :loading="busy"
          :disabled="busy || !canSubmit"
          @click="onConfirm"
        >
          {{ $t('confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// dialog specifically for LOGIN 2FA (without Bearer). Uses twofactor/challenge action.
import { mapActions } from 'vuex';
import { mapErrorsToInputs } from '@/util/forms';

export default {
    name: 'TwoFactorLoginDialog',
    props: {
        value: { type: Boolean, default: false }, // v-model for opening/closing
        email: { type: String, required: true },  // email entered in login
    },
    data: () => ({
      mode: 'otp',
      otpCode: '',
      recoveryCode: '',
      busy: false,
      errorMsg: {},
    }),
    computed: {
      isOpen: {
        get() { return this.value; },
        set(val) { this.$emit('input', val); },
      },
      canSubmit() {
        return this.mode==='otp'
          ? this.otpCode.length===6
          : this.recoveryCode.replace(/[\s-]/g,'').length>=8
      },
    },
    methods: {
        ...mapActions('twoFactor', ['challenge']),
        otpOnlyDigits() {
          this.otpCode = (this.otpCode || '').replace(/\D/g, '').slice(0, 6);
          if (this.errorMsg) {
            this.errorMsg = {}
          }
        },
        recoveryCodeRules() {
          this.recoveryCode = (this.recoveryCode || '')
            .toUpperCase()
            .replace(/[^A-Z0-9-\s]/g, '')
            .slice(0, 64);

          if (this.errorMsg) {
            this.errorMsg = {};
          }
        },
        toggleMode() {
          this.mode = this.mode==='otp' ? 'recovery' : 'otp'
          this.otpCode = ''
          this.recoveryCode = ''
          this.errorMsg = {}
        },
        async onConfirm() {
          this.busy = true;
          this.errorMsg = {};
          try {
            const payload = this.mode === 'otp'
              ? { email: this.email, otp_code: this.otpCode }
              : { email: this.email, recovery_code: this.recoveryCode }
            
            await this.challenge(payload) // withou Bearer

            this.$emit('success') // Login.vue will repeat /oauth/token
            this.isOpen = false
            this.otpCode = ''
            this.recoveryCode = ''

          } catch (e) {
            this.errorMsg = mapErrorsToInputs(e)

          } finally {
            this.busy = false
          }
        },
        onCancel() {
            this.isOpen = false
            this.$emit('cancel')
            this.otpCode = ''
            this.recoveryCode = ''
            this.errorMsg = {}
        },
    }
}
</script>